module.exports = __webpack_public_path__ + "static/img/5.bdb2337.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/sp/5.png
// module id = lVXQ
// module chunks = 0